import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';
import getters from './getters';

const state = {
  contentTrackers: [],
  parsedFileHeaders: [],
  parsedFileResult: [],
  fileUploadUuid: '',
  isImportingPlacementLevelTrackers: false,
  combinationSplit: {
    size: true,
    publisher: true,
    geo: true,
  },
  columnsToDisplay: [],
  trackersHealthStatusData: [],
  selectedTrackersForValidation: [],
  trackersSelectedCombinations: new Map(),
  groupedTrackersList: {},
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
